import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import MessageForm from './MessageForm';
import MessageContext from './MessageContext';
import RequestedDates from './RequestedDates';

const MessageThread = observer(class MessageThread extends React.Component {
  constructor() {
    super();
    this.showForm = this.showForm.bind(this);
  }

  componentWillMount() {
    this.state = {
      renderForm: false
    }

    this.getThread();
  }

  componentDidUpdate(nextProps) {
    if(nextProps.messageSid !== this.props.messageSid) {
      this.setState({
        renderForm: false
      });

      this.getThread();
    }
  }

  getThread() {
    const { messageSid } = this.props;

    if(messageSid) {
      this.props.store.MessageStore.getThread(messageSid);
    } else {
      this.props.store.MessageStore.getThreadId(this.props.toUserSid, this.props.contextType, this.props.contextId);
    }

    // Highlight the newly selected thread
    const prevThread = document.querySelector('.thread.active');

    if(prevThread && prevThread.className.indexOf('active') > -1) {
      prevThread.className = prevThread.className.replace('active', '');
    }

    let thread = null;

    const getThread = setInterval(function(){
      thread = document.querySelector(`#thread-${messageSid}`);

      if(thread) {
        thread.className += ' active';
        clearInterval(getThread);
      }
    }, 100);
  }

  showForm() {
    this.setState({
      renderForm: true
    });
  }

  initials(name, className) {
    const names = name.split(' ');
    const firstInitial = names[0].charAt(0);
    const secondInitial = names[1].charAt(0);

    if(className) {
      return `${firstInitial.toLowerCase()}`
    }

    return firstInitial + secondInitial;
  }

  renderContext() {
    const { translation } = this.props;
    const { threadObject } = this.props.store.MessageStore;
    const { exam, examSession } = threadObject;

    let examConfiguration = null;

    if(examSession && examSession.examConfiguration) {
      examConfiguration = examSession.examConfiguration;
    }

    let title = null;
    let data = [];

    if(examConfiguration && exam) {
      title = exam.title;

      if(threadObject.confirmedDate) {
        data = [
          {
            title: translation.context.exam_date,
            value: `${moment.utc(threadObject.confirmedDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}`
          }, {
            title: translation.context.duration,
            value: toHours(examConfiguration.duration, false, false, false)
          }
        ]
      } else {
        data = [
          {
            title: translation.context.exam_date,
            value: `${moment.utc(examConfiguration.examOpenDate).local().format('M/D/YYYY [at] h:mma')} – ${moment.utc(examConfiguration.examCloseDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}`
          }, {
            title: translation.context.duration,
            value: toHours(examConfiguration.duration, false, false, false)
          }
        ]
      }
    } else if (threadObject.examSid && exam) {
      title = exam.title;

      data = [
        {
          title: translation.context.exam_date,
          value: `${moment.utc(exam.examOpenDate).local().format('M/D/YYYY [at] h:mma')} – ${moment.utc(exam.examCloseDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}`
        }, {
          title: translation.context.duration,
          value: toHours(exam.duration, false, false, false)
        }
      ]
    }

    if(threadObject.proctorAccountLocation) {
      const location = threadObject.proctorAccountLocation;
      let address = location.address1;

      if(location.address2) {
        address += `, ${location.address2}`
      }

      const proctorData = [
        {
          title: translation.context.location,
          value: `${address}, ${location.place}, ${location.region} ${location.postalCode} ${location.country}`
        }
      ];

      data = data.concat(proctorData);
    }

    if(title) {
      return (
        <MessageContext
          title={title}
          data={data}
          {...this.props}
        />
      );
    }

    return '';
  }

  render() {
    const { translation } = this.props;
    const { MessageStore, SessionStore } = this.props.store;
    const { threadMessages, threadObject } = MessageStore;
    let studentName = null;

    if(!SessionStore.loading) {
      if(threadMessages.length > 0) {
        return (
          <article className="inbox__thread">
            {this.props.drawer &&
              <header className="drawer__header">
                <div className="wrap">
                  {/* <h4 className="inbox__thread-title">{activeMessage.subject}</h4> */}
                  <h1 className="drawer__title">Subject</h1>

                  <ul className="inbox__tools">
                    <li>
                      <button onClick={this.showForm}>
                        <icons.iconReply />
                        {translation.reply}
                      </button>
                    </li>
                    {/* <li>
                      <button>
                        <icons.iconArchive />
                        {translation.archive}
                      </button>
                    </li> */}
                  </ul>
                </div>
              </header>
            }

            {!this.props.drawer &&
              <header className="inbox__thread-header">
                {/* <h4 className="inbox__thread-title">{activeMessage.subject}</h4> */}
                <h5 className="inbox__thread-title">Subject</h5>

                <ul className="inbox__tools">
                  <li>
                    <button onClick={this.showForm}>
                      <icons.iconReply />
                      {translation.reply}
                    </button>
                  </li>
                  {/* <li>
                    <button>
                      <icons.iconArchive />
                      {translation.archive}
                    </button>
                  </li> */}
                </ul>
              </header>
            }

            <div className="inbox__thread-body">
              {this.renderContext()}

              <ol className="conversation">
                {threadMessages.map(
                  (message, i) => {
                    let fromUser = null;

                    if(message.fromUser) {
                      fromUser = message.fromUser;
                      studentName = `${message.fromUser.firstName} ${message.fromUser.lastName.charAt(0)}.`
                    } else {
                      fromUser = message.fromProctorAccountUser;
                    }

                    return (
                      <li key={i}>
                        <blockquote className={`conversation__message ${fromUser.sid === SessionStore.userData.sid ? 'sent' : 'received'}`}>
                          <div className="conversation__body">
                            <div className="conversation__content">
                              <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message.content.replace(/\r?\n|\r/g, ' '))}}></div>
                            </div>
                            <time className="conversation__timestamp">{moment.utc(message.createdDate).local().format('M/D/YYYY h:mma')}</time>
                          </div>

                          <cite className="conversation__author conversation__author--sm">
                            <abbr
                              className={`
                                avatar--initials conversation__avatar ${this.initials(fromUser.firstName + ' ' + fromUser.lastName, true)}
                              `}
                              title={`${fromUser.firstName} ${fromUser.lastName}`}>
                              {fromUser.firstName.charAt(0)}{fromUser.lastName.charAt(0)}
                            </abbr>
                          </cite>
                        </blockquote>
                      </li>
                    )
                  }
                )}
              </ol>

              {threadObject.proctorAccountLocation && (threadObject.dateOption1 || threadObject.confirmedDate) &&
                <RequestedDates
                  locationSid={threadObject.proctorAccountLocation.sid}
                  confirmedDate={threadObject.confirmedDate}
                  studentName={studentName}
                  {...this.props}
                />
              }

              <MessageForm
                sessionRequest={this.props.sessionRequest}
                renderForm={this.state.renderForm}
                showForm={this.showForm}
                mode={'reply'}
                threadSid={threadMessages[0].messageThreadSid}
                parentThread={this}
                {...this.props}
              />
            </div>
          </article>
        )
      }
    }

    return null;
  }
})

export default translate('MessageThread')(MessageThread);


// WEBPACK FOOTER //
// ./src/app/components/Messages/MessageThread.js